import { IFavorite } from '../types/IFavorite';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetFavoritesResult extends IGetItemsResult {
  favorites: IFavorite[];
}

export class GetFavoritesRequest extends Request<IGetItemsParams, IGetFavoritesResult> {
  constructor(params: IGetItemsParams) {
    super('getFavorites', params);
  }
}
